const CoatDriveInitialText ="Thank you for volunteering to help with the " +
    "coat drive.  The coats have arrived in a bit of a mess.  Can you sort them " +
    "so they are back in order?  Click the 'Check' " +
    "button when all items have been sorted and reassembled." +
    "You can click the 'Done' button if you decide not to complete the sorting " +
    "for all of the bins." 
        
export default CoatDriveInitialText 
 